module.exports = __webpack_public_path__ + "img/logo.2c215a72.png";